'use client'
import React from 'react'
import Loader from './Loader'

interface Props {
  customClass?: string
  label: string
  onClick?: () => void
  isLoading?: boolean
  color?: string
}

const ButtonWithLoader = ({ customClass = '', label, onClick, isLoading = false, color = 'darkRed' }: Props) => {
  return (
    <button
      onClick={onClick}
      className={`bg-${color} font-sans text-center text-16 md:text-18 h-[3.5rem] w-[100%]
                        flex items-center text-white justify-center rounded-lg ${customClass}`}>
      <div className="flex-1" />
      <div>{label}</div>
      <div className="flex-1">
        <Loader isLoading={isLoading} style={{ marginLeft: '0.5rem' }} />
      </div>
    </button>
  )
}

export default ButtonWithLoader
